import http from '@root/utils/axios/admin';

let state = {
    CitiesList: [],
    City: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCitiesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/cities', { params: filter }).then((response) => {
                commit('setCities', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCity({ commit }, id) {
        return http.delete('/api/cities/' + id);
    },

    fetchCity({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/cities/' + id).then((response) => {
                commit('setCity', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCity({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/cities', data).then((response) => {
                commit('setCity', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCityError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateCity({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/cities/' + data.id, data).then((response) => {
                commit('setCity', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCityError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCities(state, data) {
        state.CitiesList = data;
    },
    setCity(state, data) {
        state.City.data = data;
    },
    setCityError(state, error) {

        state.City.error = error.errors;
    },
    cleanCityError(state, error) {
        state.City.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}